import React, { useState } from 'react';
import { IoMdMenu, IoMdClose } from 'react-icons/io'; // Icons from react-icons

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="bg-grey-default pt-4 pb-4 pl-12 pr-12">
      <div className="container mx-auto flex justify-between items-center">
        <div className="text-white font-bold text-xl">A.Leslie</div>
        {/* Mobile menu button */}
        <div className="md:hidden">
          <button
            type="button"
            onClick={handleToggleMenu}
            className="text-white focus:outline-none"
          >
            {isOpen ? <IoMdClose size="24" /> : <IoMdMenu size="24" />}
          </button>
        </div>
        {/* Desktop menu */}
        <nav className="hidden md:flex space-x-4">
          <a
            href="/"
            className="text-white block rounded-md px-3 py-2 text-base font-medium hover:text-orange-default"
          >
            Home
          </a>
          <a
            href="/about"
            className="text-white block rounded-md px-3 py-2 text-base font-medium hover:text-orange-default"
          >
            About
          </a>
          <a
            href="/projects"
            className="text-white block rounded-md px-3 py-2 text-base font-medium hover:text-orange-default"
          >
            Projects
          </a>
          <a
            href="/contact"
            className="text-white block rounded-md px-3 py-2 text-base font-medium hover:text-orange-default"
          >
            Contact
          </a>
        </nav>
      </div>
      {/* Mobile menu */}
      <nav
        className={`md:hidden fixed top-0 left-0 h-full w-64 bg-grey-default z-20 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="pt-4 pl-4 pr-4">
          <button
            type="button"
            onClick={handleToggleMenu}
            className="text-white focus:outline-none"
          >
            <IoMdClose size="24" />
          </button>
        </div>
        <div className="mt-20 ml-12">
          <a
            href="/"
            className="text-white block rounded-md px-3 py-2 text-base font-medium hover:text-orange-default"
          >
            Home
          </a>
          <a
            href="/about"
            className="text-white block rounded-md px-3 py-2 text-base font-medium hover:text-orange-default"
          >
            About
          </a>
          <a
            href="/projects"
            className="text-white block rounded-md px-3 py-2 text-base font-medium hover:text-orange-default"
          >
            Projects
          </a>
          <a
            href="/contact"
            className="text-white block rounded-md px-3 py-2 text-base font-medium hover:text-orange-default"
          >
            Contact
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;


